import React, { FC } from 'react'

import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'

import { ProductFeatureDisplay } from '../../components/product-feature-display/ProductFeatureDisplay'

import classes from './style.module.scss'

interface ProductFeatureCardData {
  icon?: string
  text?: string
}

interface HomeProductSectionProps {
  logoUrl: string
  text: string
  buttonText: string
  onButtonClick: () => void
  desktopBackgroundUrl: string
  mobileBackgroundUrl: string
  featureCards: ProductFeatureCardData[]
}

export const HomeProductSection: FC<HomeProductSectionProps> = ({
  logoUrl,
  text,
  buttonText,
  onButtonClick,
  desktopBackgroundUrl,
  mobileBackgroundUrl,
  featureCards,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {logoUrl && (
          <img src={logoUrl} alt="Logo" className={classes.logo} />
        )}
        <Text type={TextName.Text} className={classes.text}>
          {text}
        </Text>
      </div>

      <ProductFeatureDisplay
        desktopBackgroundUrl={desktopBackgroundUrl}
        mobileBackgroundUrl={mobileBackgroundUrl}
        cards={featureCards}
      />
      
      <Button as="button" onClick={onButtonClick}>
        {buttonText}
      </Button>
    </div>
  )
}
